import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const todayISO = () => new Date().toLocaleDateString("en-CA");
const MODES = [
  ["now", "Usar agora, sem data para voltar"],
  ["until", "Usar agora até uma data"],
  ["period", "Usar só num período"],
];

export const LogoLightbox = ({ src, onOpenChange }) => (
  <Dialog open={!!src} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg p-3" data-testid="brand-lightbox">
      <DialogTitle className="sr-only">Logo ampliado</DialogTitle>
      {src && <img src={src} alt="Logo ampliado" className="w-full max-h-[75vh] object-contain rounded-xl bg-white" />}
    </DialogContent>
  </Dialog>
);

export const UseLogoDialog = ({ logo, onOpenChange, onConfirm, busy }) => {
  const [mode, setMode] = useState("now");
  const [start, setStart] = useState(todayISO());
  const [end, setEnd] = useState("");
  useEffect(() => { if (logo) { setMode("now"); setStart(todayISO()); setEnd(""); } }, [logo]);
  const valid = mode === "now" || (end && end >= (mode === "period" ? start : todayISO()));
  const confirm = () => onConfirm({
    start_date: mode === "period" ? start : null,
    end_date: mode === "now" ? null : end,
  });
  return (
    <Dialog open={!!logo} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="brand-use-dialog">
        <DialogHeader><DialogTitle>Usar este logo</DialogTitle></DialogHeader>
        {logo && <img src={logo.preview} alt="" className="w-28 h-28 mx-auto object-contain" />}
        <div className="space-y-2">
          {MODES.map(([k, l]) => (
            <label key={k} className={`flex items-center gap-2 rounded-xl border-2 px-3 py-2 cursor-pointer text-sm ${mode === k ? "border-[#7c3aed] bg-violet-50" : "border-slate-100"}`}>
              <input type="radio" checked={mode === k} onChange={() => setMode(k)} data-testid={`brand-use-${k}`} />{l}
            </label>
          ))}
        </div>
        {mode !== "now" && (
          <div className="grid grid-cols-2 gap-2">
            {mode === "period" && (
              <label className="block"><span className="block text-[11px] font-bold text-slate-500 mb-1">Começa em</span>
                <Input type="date" min={todayISO()} value={start} onChange={(e) => setStart(e.target.value)} data-testid="brand-use-start" /></label>
            )}
            <label className={`block ${mode === "until" ? "col-span-2" : ""}`}><span className="block text-[11px] font-bold text-slate-500 mb-1">Último dia (depois volta ao original)</span>
              <Input type="date" min={mode === "period" ? start : todayISO()} value={end} onChange={(e) => setEnd(e.target.value)} data-testid="brand-use-end" /></label>
          </div>
        )}
        <Button onClick={confirm} disabled={!valid || busy} className="w-full bg-[#33b679] hover:bg-[#2a9d67] text-white" data-testid="brand-use-confirm">
          {mode === "period" && start > todayISO() ? "Agendar" : "Usar agora"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
